import React from "react";
import { ExerciseEditorProps } from "./exercise-editor-types";
import { ExerciseContent } from "@org/ui";
import { Label } from "@org/ui";
import { TextArea } from "@org/ui";

export const FileUploadExerciseEditor: React.FC<ExerciseEditorProps<ExerciseContent>> = ({
  content,
  updateContent
}) => {
  const handleUpdate = (nextData: Partial<ExerciseContent["data"]>) => {
    updateContent({
      ...content,
      data: {
        ...content.data,
        ...nextData
      }
    });
  };

  return (
    <div className="space-y-4">
      <div className="rounded-md border border-blue-100 bg-blue-50 p-3">
        <p className="text-sm text-blue-800">
          Students will see a file upload zone where they can submit PDF, video (MP4/WebM/MOV), or PowerPoint files. Submissions are always manually graded.
        </p>
      </div>

      <div>
        <Label htmlFor={`correction-${content.id}`}>Grading Guidance</Label>
        <TextArea
          id={`correction-${content.id}`}
          value={content.data.correction}
          onChange={(event) => handleUpdate({ correction: event.target.value })}
          placeholder="Optional guidance for how to evaluate submitted files..."
          className="mt-1"
        />
      </div>
    </div>
  );
};
